/* eslint-disable @typescript-eslint/no-explicit-any */
import { Day, DayType } from "components/booking/admin/overviewComponents/day";
import { WeekRow, Week } from "./styled";

export const renderWeeks = (overviewData: any) => {
  if (!overviewData || !overviewData.weeks || overviewData.weeks.length === 0) {
    return null;
  }
  const { weeks } = overviewData;
  return Object.keys(weeks).map((week, index) => {
    const days = weeks[week].length !== 0 ? weeks[week] : [];
    return (
      <WeekRow key={`weekRow-${index}`}>
        <Week>{week.split("-")[1]}</Week>
        {days.map((day: DayType, dayIndex: number) => {
          return <Day day={day} key={`day-${dayIndex}`} />;
        })}
      </WeekRow>
    );
  });
};
